import { Link } from 'gatsby'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Image from '../components/image'
import Layout from '../components/layout'
import { useMediaQuery } from '../helpers'

const Custom404 = ({ location }) => {
  const isSm = useMediaQuery(768)
  return (
    <Layout location={location} title="Fehler 404">
      <Container>
        <Row>
          <Col
            className="align-items-center d-flex justify-content-center"
            style={{ minHeight: isSm ? 'calc(100vh - 400px)' : 'calc(100vh - 538px)' }}
          >
            <div className="text-center">
              <h1 className="mt-5 mt-sm-0 mb-sm-5">Ups, etwas schief gegangen..</h1>
              <Image
                alt="Error 404"
                filename="logo-broke.png"
                type="local"
                style={{ maxWidth: 163, margin: '0 auto' }}
              />
              <p className="text-center mt-2 mt-sm-5">Fehler 404 - Seite nicht gefunden. Das tut uns leid.</p>
              <p className="text-center">
                Zur <Link to="/">Homepage</Link>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default Custom404
